import { TableColumn } from 'react-data-table-component';

interface DataRowPos {
  serialNumber: string;
  date: string;
  waiter: string;
  commission: string;
  actions: string;
}

export const columnsPos: TableColumn<DataRowPos>[] = [
  {
    name: 'Nº de série',
    selector: row => row.serialNumber,
  },
  {
    name: 'Data do vínculo',
    selector: row => row.date,
  },
  {
    name: '',
    selector: row => row.actions,
    right: true,
  },
];

// eslint-disable-next-line no-shadow
export enum ShouldShowModal {
  POS = 'POS',
}

// eslint-disable-next-line no-shadow
export enum FormInputName {
  sectionId = 'sectionId',
  pos = 'pos',
  allowDiscount = 'allowDiscount',
}
